import { StoryObj } from '@storybook/react';
import { UploadContact } from '@taleemabad/dsm/components';

export default {
  title: 'Templates/ERP/Upload Contacts',
  component: UploadContact,
};

type Story = StoryObj<typeof UploadContact>;

const Template: Story = {
  render: (args) => <UploadContact {...args} />,
};

export const Default: Story = {
  ...Template,
  args: {
    contacts: [
      {
        name: 'Nabi Ahmad',
        phone: '0344455333',
      },
      {
        name: 'Ayesha Khan',
        phone: '03112223344',
      },
      {
        name: 'Imran Khan',
        phone: '03001112222',
      },
      {
        name: 'Fatima Noor',
        phone: '03215556677',
      },
      {
        name: 'Bilal Hassan',
        phone: '03334445566',
      },
    ],
  },
};

export const NoStudents: Story = {
  ...Template,
  args: {
    contacts: [],
  },
};
